<template>
  <page-outline :title="pageTitle" :color="titleColor"
    icon="icon-sent" :returnUrl="pageReturnUrl">

    <template slot="pageContent">
      <b-row v-if="this.capsule === 'draft-edit'">
        <b-col sm="6" class="form-group">
          <label style="font-size:18px;">
            {{ $t('creation_forms.drft_nm') }}<span class="color-red">* </span>
          </label>
          <input class="form-control" type="text"
            :placeholder="$t('creation_forms.drft_nm')" style="text-align: left;"
            v-model="draftName" :disabled="this.readonly">
          </input>
        </b-col>
      </b-row>

      <!-- ====================================== -->
      <!--     TEAMS (for Company Accounts)       -->
      <!-- ====================================== -->
      <form-accordion :title="$t('common.formsSubTitle.val_info')"
        v-if="accountType === '1'">
        <b-row>
          <b-col sm="6" class="form-group">
            <label>
              {{ $t('common.team_label') }}<span v-if="hasForceValidation" class="color-red">* </span>
            </label>
            <b-form-select class="form-control" id="sel1"
              :disabled="readonly" v-model="id_team"
              :options="teamOptions">
            </b-form-select>
          </b-col>
        </b-row>
      </form-accordion>

      <hr v-if="accountType === '1' && hasForceValidation" />

      <!-- ====================================== -->
      <!--   ATTACHMENTS (Bank Transfer Order)    -->
      <!-- ====================================== -->
      <form-accordion :title="$t('attachments.doc')" :open="false">
        <!-- <b-form-group>
          <b-form-radio class="creationFormBtnRadio" v-model="typeFile"
            name="transferType" value="1">
            {{ $t('common.import_device') }}
          </b-form-radio>&nbsp;&nbsp;
          <b-form-radio class="creationFormBtnRadio" v-model="typeFile"
            name="transferType" value="2">
            {{ $t('creation_forms.imprt_frm_moneyroad') }}
          </b-form-radio>
        </b-form-group> -->

        <b-row class="form-group justify-content-start">
          <b-col v-if="!demo">
            <b-form-group>
              <b-form-radio-group
                :disabled="this.readonly"
                v-model="fileIsFacturX"
                :options="fileTypeSelect">
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <div class="col-12" v-if="!readonly && typeFile === '1' && !attachement" >
            <f7-button
              class="button-round attachmentButton buttonAccordionForm longword-word generalBottomButton"
              @click="openImportAttachment(typeFile)">
              {{ fileIsFacturX ? 'Importer une Factur-X' : $t('attachments.import_doc') }}
            </f7-button>
          </div>
          <div class="col-12 scanbutton"
            v-if="!readonly && isSmartphoneOS && hasCamera">
            <f7-button round
              class="attachmentButton buttonAccordionForm generalBottomButton"
              @click="scanOrder($event)">
              {{ $t('creation_forms.scn_ordr_form') }}
            </f7-button>
          </div>
        </b-row>
        <b-row class="form-group">
          <b-col>
            <input v-model="attachementNameLabel"
              v-if="typeFile === '1' && attachementNameLabel === $t('creation_forms.imprt_file')"
              id="application-file-input"
              class="form-control inputAccordionForm"
              type="text"
              :placeholder="$t('creation_forms.slct_a_fl')"
              readonly
              :disabled="this.readonly">
            </input>
            <div class="d-flex justify-content-between">
              <label v-model="attachementNameLabel"
                v-if="typeFile === '1' && attachementNameLabel !== $t('creation_forms.imprt_file')"
                id="application-file-input">
                {{ attachementNameLabel }}
              </label>
              <div class="d-flex">
                <i class="icon fa fa-download mx-1"
                  v-if="typeFile === '1' && attachementNameLabel !== $t('creation_forms.imprt_file')"
                  @click="view(attachmentId)">
                </i>
                <i class="icon fa fa-search mx-1"
                  v-if="typeFile === '1' && attachementNameLabel !== $t('creation_forms.imprt_file')"
                  @click="openDoc(attachmentId)">
                </i>
              </div>
            </div>
            <select class="form-control" id="sel2" readonly v-model="attachmentId"
              v-if="typeFile === '2'" @change="cloudFileSel()">
              <option value="" default disabled>
                {{ this.hasCloudAttachments ? $t('creation_forms.slct_a_fl') : $t('attachments.no_document') }}
              </option>
              <option v-for="cloudDoc in cloudDocsPicker" :key="cloudDoc.id" :value="cloudDoc.id"> {{ cloudDoc.name }}</option>
            </select>
            <input class="item-input hiddenElementAllSize local-file-input" @change="onFileChange" type="file" accept=".pdf" :key="refreshImport"/>
            <input class="hiddenElementAllSize" type="text"></input>
            <input class="hiddenElementAllSize" type="text" id="recommendation-list-input"></input>
          </b-col>
        </b-row>
        <b-row v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''">
          <b-col>
            <form-write-group-label-input v-model="attachmentReference"
              :inputLabel="$t('common.rfrnc')"
              :placeholderValue="$t('common.rfrnc_desc')"
              :disabled="this.readonly">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row v-if="!readonly" class="form-group justify-content-right">
          <b-col v-if="isSmartphone" md="4" offset-md="2">
            <f7-button round v-if="hasAttachment" class="buttonAccordionForm attachmentButton generalBottomButton"
              @click="view(attachmentId)">
              {{ $t('creation_forms.view_attchmnt') }}
            </f7-button>
          </b-col>
          <b-col md="4">
            <f7-button round class="attachmentButton generalBottomButton"
              v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''"
              @click="clearAttachement()">
              {{ $t('creation_forms.clear_label') }}
            </f7-button>
          </b-col>
        </b-row>
        <b-row v-if="readonly && hasAttachment">
          <b-col v-if="isSmartphone" md="4" offset-md="2">
            <f7-button round class="buttonAccordionForm attachmentButton"
              @click="view(attachmentId)">
              {{ $t('creation_forms.view_attchmnt') }}
            </f7-button>
          </b-col>
          <b-col v-if="!isSmartphone" md="4" offset-md="2">
            <f7-button round class="buttonAccordionForm attachmentButton"
              style="width:200px;"
              @click="view(attachmentId)">
              {{ $t('creation_forms.dwnld_attchmnt') }}
            </f7-button> <!--Download-->
          </b-col>
        </b-row>
      </form-accordion>

      <hr/>

      <form-accordion :title="$t('common.formsSubTitle.item_info_DP')">
        <!-- <div class="form-group">
          <div class="row justify-content-start">
            <div class="col-md-6 col-8" :class="{blueBottomButton: isOcrActive, greyBottomButton: !isOcrActive}">
              <input class="item-input hiddenElementAllSize rib-file-input"
                @change="executeOCROnRIB" type="file">
              </input>
              <f7-button round
                class="attachmentButton buttonAccordionForm"
                @click="importRIB($event)"
                :disabled="!isOcrActive">
                {{ $t('sent.import_RIB_btn') }}
              </f7-button>
            </div>
          </div>
        </div> -->
        <b-row class="form-group">
          <b-col>
            <form-contact-dropdown-label-input v-model="beneficiaire" isMandatory
              :inputLabel="$t('common.nme')"
              :disabled="readonly"
              :placeholderValue="$t('creation_forms.bnfcr_nm')"
              :mandatoryErrorIndicator="beneficiaireError"
              @change-iban="recipientBankAccount = $event"
              @change-identifier="recipientEmail = $event"
              @change-zonecode="handleChangeRecipientZoneCode($event)">
            </form-contact-dropdown-label-input>
          </b-col>
          <b-col>
            <form-write-group-label-input v-model="recipientEmail" isMandatory
              :disabled="readonly"
              :inputLabel="$t('common.idtfr')"
              :placeholderValue="$t('creation_forms.bnfcr_email_siren')"
              :regexpErrorIndicator="recipientEmailRegexpError">
            </form-write-group-label-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="form-group">
            <label>
              {{ $t('common.account_zone') }}
              <span class="color-red">* </span>
            </label>
            <select class="form-control" id="sel4" v-model="recipientZoneCode" :disabled="readonly">
              <option v-for="country in countries" :key="country.id"
                :value="country"
                :disabled="country.disabled || (!canSelectOtherThanEuro && country.label !== 'EUR')"
                :selected="country.selected">
                {{ $t('zoneCodes.' + country.label) }}
              </option>
            </select>
          </b-col>
          <b-col class="form-group"
            v-for="accountLabel in recipientZoneCode.accountLabel"
            :key="accountLabel">
            <label>
              {{ $t('bank_accounts.bank_account_singular') }} <span class="color-red">* </span>
            </label>
            <input v-model="recipientZoneCode.values[accountLabel]"
              type="text"
              :disabled="readonly"
              name="identifier"
              class="form-control"
              :class="{'errorBorder': recipientZoneCode.errors[accountLabel] === 'missing' ||
                                      recipientZoneCode.errors[accountLabel] === 'incorrect'}"
              :placeholder="$t('common.beneficiaire_name')">
            </input>
            <div v-if="recipientZoneCode.errors[accountLabel] === 'missing'" style="color:red;">
              {{ $t('errors.is_mandatory', {mandatoryValue : $t(accountLabel) }) }}
            </div>
            <div v-else-if="recipientZoneCode.errors[accountLabel] === 'incorrect'" style="color:red;">
              {{ $t('errors.is_incorrect', {incorrectValue : $t(accountLabel) }) }}
            </div>
          </b-col>
        </b-row>
      </form-accordion>

      <hr/>

      <form-accordion :title="$t('common.formsSubTitle.my_acc_info')">
        <b-row>
          <b-col sm="6">
            <select-bank-account v-model="senderBank">
            </select-bank-account>
          </b-col>
        </b-row>
      </form-accordion>

      <!--  <form-accordion :title="$t('common.formsSubTitle.my_acc_info')">
            <div class="row">
              <div class="form-group col-sm-6">
                <label class="createInvoiceBand">
                  {{ $t('bank_accounts.my_account') }}
                  <span class="color-red">* </span>
                </label>
                <!-- <div class="col-6 showSmallScreenOnly form-group" :class="colorBottomButton">
                  <div v-if="!readonly" @click="accountPicker($event)" class="button button-round buttonAccordionForm">
                    {{ $t('common.slct') }}
                  </div>
                </div>
                <div class="col-sm-12 showSmallScreenOnly">
                  <input class="form-control" id="account-inputDP" type="text" v-model="senderBankName" placeholder="Choose account" readonly></input>
                </div>
                <select class="form-control" :class="{'errorBorder': senderBankError}"  readonly :disabled="this.readonly" v-model="senderBank">
                  <option value="">{{ $t('creation_forms.slct_an_acc') }}</option>
                  <option v-for="bankAccount in bankAccounts" :key="bankAccount.id" :value="bankAccount.iban" :disabled="!isBankAccountAvailable(bankAccount)">
                    {{ bankAccount.name }} ({{ $engine.bankAccounts.getCurrency(bankAccount.zoneCode) }})
                  </option>
                </select>
                <div v-if="senderBankError" style='color:red;'>
                  {{ $t('errors.is_mandatory', { mandatoryValue : $t('common.act') }) }}
                </div>
              </div>
            </div>
          </form-accordion>-->

      <hr/>

      <form-accordion :title="$t('common.formsSubTitle.dir_pymnts_dtls')">
        <!-- ====================================== -->
        <!--      DIRECT PAYMENTS PARAMETERS        -->
        <!-- ====================================== -->
        <b-row>
          <b-col md="6">
            <b-row class="form-group">
              <b-col style="padding-left:1.5em">
                <b-form-checkbox
                  v-model="instantPayment"
                  :disabled="readonly"
                  :value="1"
                  :unchecked-value="0"
                  @change="changeInstPmt">
                  {{ $t('creation_forms.inst_pymnt_form') }}
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="decision"
                  :disabled="readonly"
                  :value="1"
                  :unchecked-value="0">
                  {{ $t('directPayments.dir_pymnt_decision_form') }}
                </b-form-checkbox>
                <!-- <b-form-checkbox
                  v-model="isOcrActive"
                  :disabled="readonly"
                  :value="true"
                  :unchecked-value="false"
                  style="margin-top: 2px;">
                  {{ $t('common.activate_OCR_form') }}
                </b-form-checkbox> -->
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="remittanceInformation" isMandatory
              :inputLabel="$t('common.rsn')" :placeholderValue="$t('common.rsn')"
              :mandatoryErrorIndicator="remittanceInformationError"
              :disabled="this.readonly">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="executionDate" isMandatory
              inputType="date" disablePastDates
              :inputLabel="$t('common.execution_date_label')" :placeholderValue="$t('common.date_label')"
              :mandatoryErrorIndicator="executionDateError"
              :disabled="isInstantPayment || this.readonly">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="amount" isMandatory
              :inputType="'number'"
              :inputLabel="$t('common.amnt')"
              :placeholderValue="$t('common.amnt')"
              :mandatoryErrorIndicator="amountError"
              :intervalErrorIndicator="amountIntervalError"
              :disabled="this.readonly">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr v-if="validators.length > 0" />

      <form-accordion :title="$t('common.formsSubTitle.valid')" v-if="validators.length > 0">
        <b-row class="form-group">
          <b-col>
            <table class="table table-striped table-bordered table-status-history">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">{{ $t('common.status.status_label') }}</th>
                  <th scope="col">{{ $t('common.group_label') }}</th>
                  <th scope="col">{{ $t('common.vldt_user') }}</th>
                  <th scope="col">{{ $t('common.date_vldt') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="validator in sortedValidators" :key="validator.groupLabel">
                  <td class="longword dateTimehistoryHeight">
                    <span v-if="validator.idAccount !== ''">
                      <f7-icon fa="check" style="font-size: 16px; color: green; padding-right:10px">
                      </f7-icon>
                      {{ $t('common.vldtd_label') }}
                    </span>
                    <span v-else>
                      <f7-icon fa="clock-o" class="streammindBlueFont" style="font-size: 16px; padding-right:10px">
                      </f7-icon>
                      {{ $t('common.wtng_label') }}
                    </span>
                  </td>
                  <td class="longword dateTimehistoryHeight"><b>{{ validator.groupLabel }}</b></td>
                  <td class="longword dateTimehistoryHeight">
                    <div v-if="validator.idAccount !== ''">
                      {{ validator.name }}
                      <div class="item-title-row">
                        <span class="versionSubTitle">
                          {{ validator.identifier }}
                        </span>
                      </div>
                    </div>
                    <span v-else>---</span>
                  </td>
                  <td class="showLargeScreenOnly dateTimehistoryHeight" style="padding-right: 30px;">
                    <div v-if="validator.idAccount !== ''">
                      {{ validator.horodatage | formatDateTime }}
                    </div>
                    <div v-else>
                      {{ $t('creation_forms.pndng') }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </form-accordion>

      <!--REFUSE DRAFT HISTORY-->
      <hr v-if="versionNumber > 1" />

      <form-accordion :title="$t('common.formsSubTitle.rfsl_hstr')" v-if="versionNumber > 1">
        <b-row class="form-group">
          <b-col>
            <label class="labelAccordionForm">
              {{ $t('creation_forms.vrsn') }}
              <b>
                {{ parseInt(versionNumber) - 1 }}
              </b>
              {{ $t('creation_forms.rfsd_by') }}
              <b>
                {{ refuseUsername }}
              </b>
              {{ $t('creation_forms.from') }}
              <b>
                {{ refuseGroupLabel }}
              </b>.
            </label>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <label class="labelAccordionForm">
            {{ $t('creation_forms.rsn_ws') }}:
          </label>
          <label class="labelAccordionForm">
            {{ refuseReason }}
          </label>
        </b-row>
      </form-accordion>
    </template>

    <template slot="footerButtons">
      <b-row class="form-group">
        <b-col md="10" offset-md="1">
          <b-row class="justify-content-end">
            <!-- <div class="col-md-3" v-if="!readonly">
              <button round v-bind:class="savePosition" class="button-action firstButtonMarginTop milkyBlockBlack" @click="getNameDraft">
                <i class="icon fa fa-save"></i>
                {{ $t('creation_forms.sv_rqust') }}
              </button>
            </div> -->
            <!--
              v-if="(accountType === '2' ||
                    ((clearance === '1' | clearance === '2') &&
                    isValidated === '1')) || printValidateButton || !hasForceValidation" -->
            <b-col md="3">
              <!--
                v-if="accountType === '2' ||
                      ((clearance === '1' | clearance === '2') &&
                      isValidated === '1') || !hasForceValidation" -->
              <f7-button v-if="!readonly"
                class="button-action milkyBlockBlack"
                @click="getNameDraft">
                <f7-icon fa="save"></f7-icon>
                {{ $t('creation_forms.sv_dp_drft') }}
              </f7-button>
            </b-col>
            <b-col v-if="printValidateButton && !readonly" md="3">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="validateAndSaveButton">
                <f7-icon fa="check"></f7-icon>
                <span>{{ $t('creation_forms.sv_snd_dp_dft') }}</span>
              </f7-button>
            </b-col>
            <b-col v-if="canSendPayment" md="3">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="sendDirectPayments">
                <f7-icon fa="paper-plane"></f7-icon>
                {{ $t('creation_forms.send_dp') }}
              </f7-button>
            </b-col>
            <b-col v-if="printValidateButton" md="3">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="valideDraft">
                <f7-icon fa="check"></f7-icon>
                <span>{{ $t('creation_forms.vldt') }}</span>
              </f7-button>
            </b-col>
            <b-col v-if="printValidateButton && isHighestValidator" md="3">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="valideAndSendDraft">
                <f7-icon fa="paper-plane"></f7-icon>
                {{ $t('creation_forms.vldt_and_snd') }}
              </f7-button>
            </b-col>
            <b-col v-if="canRefuseDraft" md="3">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="refuseDraft">
                <f7-icon fa="ban"></f7-icon>
                {{ $t('common.refus') }}
              </f7-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import b64toBlob from 'b64-to-blob'
import moment from 'moment'

import FormAccordion from '@/components/common/FormAccordion.vue'
import FormContactDropdownLabelInput from '@/components/common/formContactDropdownLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'

import {createIbanUK, createForeignIban, extractForeignIban} from '@/helpers/format'
import datePickerMixin from '@/mixins/datePickerMixin'
import {errorMessageAlert} from '@/helpers/alert'
// import {get} from '@/helpers/api'
// import {getPayments} from '@/helpers/payments'
import {loadPage, reloadPage} from '@/helpers/routing'
// import PaymentsSentboxPage from '@/pages/services/payments/CMSendboxPage.vue'
import {validateAccountFormat, validateEmail, validateSIREN, verifyMandatoryValues,
        verifyRegexpValues, verifyIntervalValues, checkErrorFlag, isEmptyValue} from '@/helpers/validator'

export default {
  mixins: [datePickerMixin],
  name: 'DPCreateTemplate',
  props: ['subNavTitle', 'capsule', 'saveMessage'],
  components: {
    'form-accordion': FormAccordion,
    'form-contact-dropdown-label-input': FormContactDropdownLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'select-bank-account': selectBankAccount
  },
  data () {
    return {
      demo: true,
      refreshImport: false,
      accountNumber: '',
      accountsPicker: '',
      accountType: '',
      amount: '',
      amountError: false,
      amountIntervalError: false,
      attachement: '',
      attachmentId: '',
      attachmentName: '',
      attachmentReference: '',
      bankAccounts: [],
      beneficiaire: '',
      beneficiaireError: false,
      canSelectOtherThanEuro: false,
      canSendAttachment: false,
      cloudDocsPicker: '',
      cloudFiles: [],
      contacts: [],
      contactsPicker: '',
      contactsObject: {},
      contactSelected: false,
      contactSelectionList: [],
      countries: '',
      countryPicker: '',
      currency: '',
      decision: 0,
      directPayments: '0',
      draftName: '',
      enteredDebtors: [],
      executionDate: '',
      executionDateError: false,
      fileIsFacturX: false,
      fromCloud: false,
      fileTypeSelect: [
        {
          text: this.$i18n.t('common.classic_invce_radio'),
          value: false
        },
        {
          text: this.$i18n.t('common.facturx_radio'),
          value: true
        }
      ],
      hasAttachment: false,
      hasCloudAttachments: false,
      id_team: '',
      idDraft: '',
      identifier: '',
      ImmPmtAccepted: false,
      instantPayment: 0,
      isComplete: '0',
      isOcrActive: true,
      isSmartphone: false,
      isSmartphoneOS: false,
      isValidated: '0',
      label_team: '',
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      loadingFile: false,
      modificationAccepted: false,
      recipientBank: '',
      recipientBankAccount: '',
      recipientEmail: '',
      recipientEmailError: false,
      recipientEmailRegexpError: false,
      recipientName: '',
      recipientZoneCode: {
        id: 0,
        label: 'slct_zone',
        disabled: true,
        selected: true
      },
      recipientZoneCodeError: false,
      refuseGroupLabel: '',
      refuseReason: '',
      refuseUsername: '',
      remittanceInformation: '',
      remittanceInformationError: false,
      selected: null,
      selectedDebtor: {},
      senderBank: '',
      senderBankError: false,
      senderBankName: '',
      sendPaymentsClicked: false,
      sortCode: '',
      teams: [],
      teamOptions: [],
      teamsPicker: '',
      typeFile: '1',
      titleColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id),
      validators: [],
      validatorsGroups: '',
      versionNumber: '1'
    }
  },
  computed: {
    attachementNameLabel () {
      if (this.attachmentName === '' && this.isSmartphone) {
        return this.$i18n.t('creation_forms.imprt_or_scn_file')
      } else if (this.attachmentName === '') {
        return this.$i18n.t('creation_forms.imprt_file')
      } else if (this.attahmentName === '' && this.readonly) {
        return this.$t('common.no_doc')
      } else {
        return this.attachmentName
      }
    },
    canRefuseDraft () {
      return this.isValidator && this.isValidated === '2'
    },
    canSendPayment () {
      const unsavedButHighestHierarchy = (this.validators === undefined || this.validators.length === 0) && this.isHighestValidator
      // const unsavedButHighestHierarchy = false
      return this.accountType === '2' || (this.accountType === '1' && (this.isValidated === '1' || unsavedButHighestHierarchy))
      // return this.accountType === '2' || (this.accountType === '1' && (this.isValidated === '1' || this.hasForceValidation || unsavedButHighestHierarchy))
    },
    hasCamera () {
      return navigator.camera !== undefined
    },
    hasForceValidation () {
      return this.$engine.rights.rightIs('team_skip_validation', false)
    },
    idGroup () {
      const teams = this.$engine.accounts.getMembersGroup().filter(item => item.id_team === this.id_team)
      if (teams.length > 0) {
        const groups = teams[0].groups.filter(group => group.members.map(member => member.id_user_account).includes(this.$engine.user.get().userAccountId))
        if (groups.length > 0) {
          return groups[0].id_group
        }
      }
      return -1
    },
    isHighestValidator () {
      const teams = this.$engine.accounts.getMembersGroup().filter(item => item.id_team === this.id_team)
      if (teams.length > 0) {
        const groups = teams[0].groups
        const highLevel = groups.reduce((acc, group) => {
          if (group.level > acc) {
            return group.level
          } else {
            return acc
          }
        }, 0)
        if (highLevel !== 0) {
          const group = groups.filter(group => group.level === highLevel)[0]
          return group.id_group === this.idGroup
        }
      }
      return false
    },
    isInstantPayment () {
      return this.instantPayment === 1
    },
    isValidator () {
      const groups = this.validators.filter(group => group.groupId === this.idGroup)
      if (groups.length > 0) {
        return groups[0].identifier === ''
      }
      return false
    },
    /* mandatoryDebtorEmail () {
      let decision = this.$engine.settings.directPayments.get().decision_creancier
      return decision !== '0'
    }, */
    pageReturnUrl () {
      if (this.capsule === 'draft-edit') {
        return '/inbox/2/0'
      } else {
        return '/home/'
      }
    },
    pageTitle () {
      if (this.capsule === 'draft-edit') {
        return this.$t('common.edit_item', { itemname: this.$t('servicesNames.dir_pymnts_sing') })
      } else {
        return this.$t('common.new_item', { itemname: this.$t('servicesNames.dir_pymnts_sing') })
      }
    },
    printValidateButton () {
      let decision = this.accountType === '1' &&
            ((this.isValidated === '0' || this.isValidated === '2') &&
            this.isComplete === '1' && this.isValidator === true)
      return decision
    },
    readonly () {
      return this.accountType === '1' && this.isComplete === '1' && (this.isValidated === '1' || this.isValidated === '2')
    },
    savePosition () {
      return {
        leftfav2: this.accountType === '2' || this.isValidated === '1' ||
                  (this.accountType === '1' && this.isComplete === '1' &&
                    (this.isValidated === '0' || this.isValidated === '2'))
      }
    },
    senderZoneCodeLabel () {
      if (this.senderBank !== '') {
        return this.bankAccounts.filter(bkAct => { return bkAct.iban === this.senderBank })[0].zoneCode
      } else {
        return this.$i18n.t('zoneCodes.EUR')
      }
    },
    sortedValidators () {
      return this.validators.sort((v2, v1) => v1.level - v2.level)
    }
  },
  mounted () {
    this.$engine.services.directPayments.contactDebtorList = []
    if (this.accountType === '1') {
      if (this.capsule === 'draft-edit') {
        this.createTeamPicker()
      } else {
        this.$engine.accounts.fetchPersonnalTeams().then(() => { this.createTeamPicker() })
      }
    }
    // Guangze: get default modificationAccepted value
    this.modificationAccepted = this.$engine.settings.get(6).defaultNegotiationAllowed === '1'
    if (this.modificationAccepted) {
      this.Dom7('.checkboxModificationAccepted').prop('checked', true)
    }

    /* IRY 04/2020 Par défaut le compte recipient est 'EU' */
    this.recipientZoneCode = this.$engine.bankAccounts.getZoneData('EUR')
    this.recipientZoneCode.values = {}
    if (this.recipientBankAccount) {
      this.handleChangeRecipientZoneCode('EUR')
    }
  },
  created () {
    let that = this
    this.canSelectOtherThanEuro = this.$engine.rights.rightIs('dp_request_other_euro', true)
    this.canSendAttachment = this.$engine.rights.rightIs('dp_request_add_attachment', true)
    this.setTeams()

    // Valeur par défaut de Instant Payment
    this.instantPayment = this.$engine.settings.directPayments.get().pacs008 === '1' ? 1 : 0
    // Valeur par défaut de Decision Receiver
    this.decision = this.$engine.settings.directPayments.get().decision_creancier === '1' ? 1 : 0

    that.countries = this.$engine.bankAccounts.getZoneCode()
    if (that.$engine.services.directPayments.filter.smartphoneStorage) {
      that.isSmartphone = true
    }

    // Check if temp document
    if (this.$engine.services.businessDocuments.getTempDocument()) {
      const that = this
      // Get Temp Document data
      const {DocumentIdentifier, IdDocument, Reference, Type} = this.$engine.services.businessDocuments.getTempDocument()
      // Clear Temp Document cache
      this.$engine.services.businessDocuments.clearTempDocument()

      // console.log(DocumentIdentifier, IdDocument, Reference, Type)

      // Set document info
      this.attachmentName = Reference
      this.attachmentId = IdDocument
      this.attachmentReference = DocumentIdentifier

      // Get document content and extract autofill data
      this.$f7.showPreloader('Chargement du document lié')
      this.$engine.services.businessDocuments.getAttachment(IdDocument)
      .then(response => {
        that.$f7.hidePreloader()
        that.attachement = response.data.document_data
        if (Type === 'FACTUR-X') {
          that.executeFacturX(that.attachement)
        } else {
          that.executeOCR('INVOICE', that.attachement)
        }
      })
      .catch(error => {
        that.$f7.hidePreloader()
        console.error(error)
      })
    }

    /** TLV 30/03/2020
    * isSmartphoneOS ne doit être activé QUE si l'utilisateur est sur un smartphone
    * Il ne doit jamais passer à true si l'utilisateur est sur son PC
    * (Pour afficher le bouton "Scan" qui accès à la camera du smartphone)
    */
    if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
      this.isSmartphoneOS = true
    }
    this.isOcrActive = this.$engine.settings.directPayments.get().ocrActivation === '1'

    that.payNumber = 1

    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.enteredDebtors = this.$engine.services.payments.debtorList
    // TODO : selected
    // this.selected = this.$engine.services.payments.contactDebtorList
    this.selected = ''
    this.$engine.services.payments.contactDebtorList = []
    this.$engine.services.payments.contactGroupsSelected = []
    // this.contacts = this.$settings.currentAccount.contacts
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()
    this.loadingFile = false
    this.fromCloud = false
    // Date execution = aujourd'hui + 1 jour par défaut (demandé par un client)
    this.executionDate = this.instantPayment === 1 ? moment().format('YYYY-MM-DD') : moment().add(1, 'day').format('YYYY-MM-DD')
    // this.executionDate = moment().format('YYYY-MM-DD')

    this.bankAccounts = this.$engine.bankAccounts.get()
    // TLV 28/01/2020 : Compte par défaut sur le formulaire
    this.senderBank = this.bankAccounts.filter(bkAct => { return bkAct.isDefault === '1' })
    if (this.senderBank.length > 0) {
      this.senderBank = this.senderBank[0].iban
    } else {
      this.senderBank = ''
    }

    this.senderBankName = ''
    that.attahmentName = 'File'
    if (typeof (this.$settings.preChargedFile) !== 'undefined') {
      if (this.$settings.preChargedFile.fromCloudList === true) {
        this.fromCloud = true
        this.attachmentId = this.$settings.preChargedFile.id
        this.attachmentName = this.$settings.preChargedFile.name
        this.attachement = this.$settings.preChargedFile.data
        this.attachmentReference = this.$settings.preChargedFile.reference
        this.amount = this.$settings.preChargedFile.amount
        this.executionDate = this.$settings.preChargedFile.executionDate
        this.beneficiaire = this.$settings.preChargedFile.beneficiaire
        this.recipientEmail = this.$settings.preChargedFile.debtorEmail
        this.recipientBankAccount = this.$settings.preChargedFile.recipientBankAccount
        this.remittanceInformation = this.$settings.preChargedFile.remittanceInformation
        if (this.beneficiaire !== '' && this.recipientEmail === '') {
          for (i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].name === this.$settings.preChargedFile.beneficiaire) {
              that.beneficiaire = this.contacts[i].name
              that.recipientBankAccount = this.contacts[i].iban
              that.recipientEmail = this.contacts[i].identifier
            }
          }
        }
      }
    }
    this.$settings.preChargedFile = undefined
    /** TLV 26/09/2019
    * Correction de l'erreur de chargement de draft quand le draft est vide
    * dû au fait que le preChargedDraft était vidé sans être empty au onDestroy()
    */
    /** IRY 09/10/2019
    * Modification de la condition : les données du draft ne se chargeaient pas s'il n'y avait pas de PJ
    */
    if (typeof (this.$settings.preChargedDraft) !== 'undefined') {
      for (let i = 0; i < this.bankAccounts.length; i++) {
        if (this.bankAccounts[i].iban === this.$settings.preChargedDraft.DebtorBankAccount) {
          this.senderBankName = this.bankAccounts[i].name
        }
      }
      if (this.$settings.preChargedDraft.AttachmentId !== '') {
        this.attachmentId = this.$settings.preChargedDraft.AttachmentId
      }
      if (this.$settings.preChargedDraft.AttachmentName !== '') {
        this.attachmentName = this.$settings.preChargedDraft.AttachmentName
      }
      if (this.$settings.preChargedDraft.Attachment !== '' && this.$settings.preChargedDraft.Attachment !== '$NotFound') {
        this.attachement = this.$settings.preChargedDraft.Attachment
      }
      if (this.$settings.preChargedDraft.AttachmentReference !== '') {
        this.attachmentReference = this.$settings.preChargedDraft.AttachmentReference
      }
      if (this.$settings.preChargedDraft.CreditorName != null) {
        this.beneficiaire = this.$settings.preChargedDraft.CreditorName
      }
      if (this.$settings.preChargedDraft.CreditorBankAccount !== '') {
        this.recipientBankAccount = this.$settings.preChargedDraft.CreditorBankAccount
      }
      if (this.$settings.preChargedDraft.CreditorIdentifier !== '') {
        this.recipientEmail = this.$settings.preChargedDraft.CreditorIdentifier
      }
      if (this.$settings.preChargedDraft.DebtorBankAccount !== '') {
        this.senderBank = this.$settings.preChargedDraft.DebtorBankAccount
      }
      if (this.$settings.preChargedDraft.RemittanceInformation !== '') {
        this.remittanceInformation = this.$settings.preChargedDraft.RemittanceInformation
      }
      if (this.$settings.preChargedDraft.RequestedExecutionDate !== '') {
        this.executionDate = this.$settings.preChargedDraft.RequestedExecutionDate
      }
      if (this.$settings.preChargedDraft.Amount !== '') {
        this.amount = this.$settings.preChargedDraft.Amount
      }
      if (this.$settings.preChargedDraft.ModificationAccepted === 'true') {
        this.modificationAccepted = true
      } else if (this.$settings.preChargedDraft.ModificationAccepted === 'false') {
        this.modificationAccepted = false
      }
      if (this.$settings.preChargedDraft.creditorEmail !== '') {
        this.creditorEmail = this.$settings.preChargedDraft.CreditorIdentifier
      }
      if (this.$settings.preChargedDraft.draftName !== '') {
        this.draftName = this.$settings.preChargedDraft.draftName
      }
      if (this.$settings.preChargedDraft.isComplete !== '') {
        this.isComplete = this.$settings.preChargedDraft.isComplete
      }
      if (this.$settings.preChargedDraft.isValidated !== '') {
        this.isValidated = this.$settings.preChargedDraft.isValidated
      }
      if (this.$settings.preChargedDraft.isValidator !== '') {
        // this.isValidator = this.$settings.preChargedDraft.isValidator
      }
      if (this.$settings.preChargedDraft.idGroup !== '') {
        // this.idGroup = this.$settings.preChargedDraft.idGroup
      }
      this.idDraft = this.$settings.preChargedDraft.idDraft

      this.recipientZoneCode = this.$engine.bankAccounts.getZoneData(this.$settings.preChargedDraft.recipientZoneCode)
      if (this.$settings.preChargedDraft.recipientZoneCode != null && this.$settings.preChargedDraft.recipientZoneCode !== '') {
        this.recipientZoneCode = this.$engine.bankAccounts.getZoneData(this.$settings.preChargedDraft.recipientZoneCode)
      }
      // this.recipientZoneCode.currencyLabel = this.$settings.preChargedDraft.currency
      if (this.recipientZoneCode.label === 'GBP' && this.recipientBankAccount !== '') {
        let extracted = extractForeignIban(this.recipientBankAccount)
        this.sortCode = extracted.sortCode
        this.accountNumber = extracted.accountNumber
        this.recipientBankAccount = ''
      }

      if (typeof (this.$settings.preChargedDraft.validators) !== 'undefined') {
        this.validators = this.$settings.preChargedDraft.validators
      }
      if (this.$settings.preChargedDraft.validatorsGroups !== undefined) {
        this.validatorsGroups = this.$settings.preChargedDraft.validatorsGroups
      }

      if (this.$settings.preChargedDraft.idTeam !== undefined) {
        this.id_team = this.$settings.preChargedDraft.idTeam
      }

      if (this.$settings.preChargedDraft.versionNumber !== undefined) {
        this.versionNumber = this.$settings.preChargedDraft.versionNumber
      }

      if (this.$settings.preChargedDraft.refuseGroupLabel !== undefined) {
        this.refuseGroupLabel = this.$settings.preChargedDraft.refuseGroupLabel
      }

      if (this.$settings.preChargedDraft.refuseUsername !== undefined) {
        this.refuseUsername = this.$settings.preChargedDraft.refuseUsername
      }

      if (this.$settings.preChargedDraft.refuseReason !== undefined) {
        this.refuseReason = this.$settings.preChargedDraft.refuseReason
      }

      if (this.recipientZoneCode.label === 'GBP' && this.recipientBank !== '') {
        let extracted = extractForeignIban(this.recipientBank)
        this.sortCode = extracted.sortCode
        this.accountNumber = extracted.accountNumber
        this.recipientBank = ''
      }
      this.ImmPmtAccepted = this.$settings.preChargedDraft.ImmPmtAccepted
      if (this.$settings.preChargedDraft.idTeam !== undefined) {
        this.id_team = this.$settings.preChargedDraft.idTeam
        this.$engine.accounts.fetchPersonnalTeams().then(() => {
          this.label_team = this.$engine.accounts.getPersonnalTeams().filter(team => { return team.id_team === this.id_team })[0].team_label
        })
      }
      if (this.$settings.preChargedDraft.instantPayment !== undefined && this.$settings.preChargedDraft.instantPayment !== '') {
        this.instantPayment = this.$settings.preChargedDraft.instantPayment
      }
      if (this.$settings.preChargedDraft.decision !== undefined && this.$settings.preChargedDraft.decision !== '') {
        this.decision = this.$settings.preChargedDraft.decision
      }
    }

    this.$settings.preChargedDraft = undefined

    let contactsMap = this.contacts.map(function (obj) {
      let rObj = {}
      rObj[obj.label] = obj
      return rObj
    })
    let contactsMapObj = Object.assign({}, ...contactsMap)
    this.contactsPicker = this.$f7.picker({
      input: '#bookContacts',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(contactsMapObj)
        }
      ],
      onClose: function (p) {
        that.recipientName = contactsMapObj[p.value].name
        that.recipientBank = contactsMapObj[p.value].iban
        that.recipientEmail = contactsMapObj[p.value].identifier
        that.contacts = contactsMapObj[p.value]
      }
    })

    let ibansMap = this.bankAccounts.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = {iban: obj.iban, zone: obj.zoneCode}
      return rObj
    })
    let ibansMapObj = Object.assign({}, ...ibansMap)
    this.accountsPicker = this.$f7.picker({
      input: '#account-inputDP',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(ibansMapObj)
        }
      ],
      onClose: function (p) {
        that.senderBank = ibansMapObj[p.value].iban
        that.senderBankName = p.value
        that.recipientZoneCode = ibansMapObj[p.value].zone
      },
      onOpen: function (p) {
        // that.senderBankName = p.value
      }
    })
    let params = {
      idAcct: this.$engine.user.get().id
    }
    that.$engine.attachments.getRefresh(params).then(response => {
      this.cloudFiles = response.data.docs
      let filesMap = this.cloudFiles.map(function (obj) {
        let rObj = {}
        rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
        return rObj
      })
      let filesMapObj = Object.assign({}, ...filesMap)
      if (Object.keys(filesMapObj).length > 0) {
        this.hasCloudAttachments = true
      }
      /* let values = []
      if (Object.keys(filesMapObj).length > 0) {
        values = Object.keys(filesMapObj)
        this.hasCloudAttachments = true
      } else {
        values = ['No attachments in MoneyRoad Cloud']
      } */
      if (this.hasCloudAttachments) {
        this.cloudDocsPicker = filesMapObj

        /* this.$f7.picker({
          input: '#application-file-input',
          rotateEffect: true,
          cols: [
            {
              textAlign: 'center',
              values: values
            }
          ],
          onClose: function (p) {
            if (Object.keys(filesMapObj).length > 0) {
              if (filesMapObj[p.value].id !== that.attachmentId) {
                that.attachmentId = filesMapObj[p.value].id
                that.cloudFileSel()
              }
            }
          },
          onOpen: function (p) {
            if (Object.keys(filesMapObj).length > 0) {
              that.attachmentName = p.value
            }
          }
        }) */
      }

      let label = []
      this.countries.forEach((x, y) => {
        label.push(x.label)
      })
      that.countryPicker = this.$f7.picker({
        input: '#ListCountry',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: label
          }
        ],
        onClose: function (p) {
          that.recipientZoneCode = p.value[0]
        }
      })
    })
    .catch(err => {
      errorMessageAlert(err, that)
    })
    this.accountType = this.$engine.user.get().type

    if (this.attachmentId !== '$NotFound' && this.attachmentId !== undefined && this.attachmentId !== '') {
      this.hasAttachment = true
    }
  },
  beforeDestroy () {
    this.attachmentName = ''
    this.attachment = ''
    this.recipientName = ''
    this.recipientBank = ''
    this.senderBank = ''
    this.recipientEmail = ''
    this.remittanceInformation = ''
    this.executionDate = ''
    this.amount = ''
    this.attachmentReference = ''
    this.modificationAccepted = false
    this.attachmentId = ''
    this.loadingFile = ''
    this.fromCloud = ''
    this.bankAccounts = ''
    this.contacts = []
    this.cloudFiles = []
    this.ImmPmtAccepted = false
    this.cloudDocsPicker = ''
    this.accountsPicker = ''
    this.countryPicker = ''
    this.draftName = ''
    this.recipientZoneCode = {}
    this.id_team = ''
    this.label_team = ''

    let attachmentObj = {
      fromCloudList: false,
      id: 0,
      name: '',
      data: '',
      amount: 0,
      reference: '',
      debtorName: '',
      executionDate: ''
    }
    let draftObj = {
      Amount: '',
      AttachmentId: '',
      AttachmentName: '',
      AttachmentReference: '',
      CreditorBankAccount: '',
      CreditorIdentifier: '',
      DebtorBankAccount: '',
      DebtorIdentifier: '',
      DebtorName: '',
      ImmPmtAccepted: '',
      ModificationAccepted: '',
      PymtNtr: '',
      RemittanceInformation: '',
      RequestedExecutionDate: '',
      draftName: '',
      idAccount: '',
      idDraft: '',
      isComplete: '',
      recipientZoneCode: '',
      debtorZoneCode: ''
    }
    this.$engine.settings.set({preChargedFile: attachmentObj})
    this.$engine.settings.set({preChargedDraft: draftObj})
  },
  watch: {
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader(this.$i18n.t('common.imprtng'))
      } else {
        this.$f7.hidePreloader()
      }
    }
  },
  methods: {
    accountPicker (e) {
      e.stopPropagation()
      this.accountsPicker.open()
    },
    changeInstPmt (val) {
      this.instantPayment = val
      this.executionDate = val === 1 ? moment().format('YYYY-MM-DD') : moment().add(1, 'day').format('YYYY-MM-DD')
    },
    clearAttachement () {
      this.refreshImport = !this.refreshImport
      this.attachement = ''
      this.attachmentName = ''
      this.attachmentReference = ''
      this.attachmentId = ''
      this.hasAttachment = false
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachmentId.toString())
        .then(response => {
          that.attachmentName = response.data.document_name
          that.attachement = response.data.document_data
          that.loadingFile = false
          that.attachmentReference = response.data.internal_reference
          that.Dom7('.fileNameDisplay').text(that.attachmentName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    convertDateFormat () {
      this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    },
    createImage (file) {
      console.log('create image')
      var that = this
      var reader = new FileReader()
      reader.onload = (e) => {
        console.log('reader onload')
        that.attachement = reader.result
        if (that.isOcrActive === true) {
          console.log('ocr is active')
          if (this.fileIsFacturX) that.executeFacturX(that.attachement)
          else that.executeOCR('INVOICE', that.attachement)
        }
      }
      reader.readAsDataURL(file)
    },
    createTeamPicker () {
      let that = this
      this.teams = this.$engine.accounts.getPersonnalTeams()
      this.teamsPicker = this.$f7.picker({
        input: '#teamSelect',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: that.teams.map(team => { return team.team_label })
          }
        ],
        onClose: function (p) {
          // Store team that has selected label
          let selectedTeam = that.teams.filter(team => { return team.team_label === p.value[0] })
          // If team exists, get it's id and label
          if (selectedTeam.length > 0) {
            selectedTeam = selectedTeam[0]
            that.id_team = selectedTeam.id_team
            that.label_team = selectedTeam.team_label
          }
        }
      })
    },
    debtorPicker (e) {
      e.stopPropagation()
      if (this.loadingFile === true) { return }
      this.contactsPicker.open()
    },
    /* Only work for downloading files on Mobile devices */
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(filePath.split('/')[filePath.split('/').length - 1], 'Following file successfully saved.')
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    executeFacturX (file) {
      let that = this

      // key : IHM reception parameter, value : OCR returned data
      const exchangeData = {
        recipientName: 'CreditorName',
        recipientBank: 'CreditorIban',
        recipientEmail: 'CreditorMail',
        executionDate: 'ExecutionDate',
        amount: 'AmountTTC',
        remittanceInformation: 'InvoiceReference',
        attachmentReference: 'InvoiceReference'
      }

      that.$f7.showPreloader(that.$i18n.t('sent.facturx_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return that.$engine.services.facturx(file)
      .then(response => {
        // console.log('--- response', response)
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.facturx_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()

        // Extract data from response
        response = response.data
        // console.log('--- response.data', response)

        // Replace form values with OCR values
        for (var key in exchangeData) {
          var ExtractedValue = response[exchangeData[key]]
          if (ExtractedValue) {
            if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
              ExtractedValue = ''
            }
            // Formatting values from OCR to conform to accepted formats
            if (exchangeData[key] === 'Amount') ExtractedValue = ExtractedValue.replace(/,/g, '.') // `comma` -to-> `period`
            else if (exchangeData[key] === 'DebtorIban' || exchangeData[key] === 'CreditorIban') ExtractedValue = ExtractedValue.replace(/ /g, '') // Delete spaces

            that[key] = ExtractedValue
            if (key === 'beneficiaire') {
              let contacts = this.$engine.contacts.get()
              for (var kContact in contacts) {
                if (contacts[kContact].name.toUpperCase() === ExtractedValue.toUpperCase()) {
                  that.recipientEmail = contacts[kContact].identifier
                }
              }
            }
          }
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.file_not_read') + ' ' + err)
        console.log(that.$i18n.t('errors.file_not_read') + ' ' + err)
      })
    },
    executeOCROnRIB (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        var reader = new FileReader()
        reader.onload = (e) => {
          that.executeOCR('RIB', e.target.result)
        }
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 50Mo', 'Maximum file size exceeded')
      }
    },
    /** @author ERI- TLV
    * @date 27/03/2020
    * @brief méthode qui execute l'OCR à partir de l'Order transmis en paramètre
    *     et qui affiche les données retournées sur l'IHM
    * @param filetype may be: RIB, Invoice, Order
    * @param file est l'image chiffrée en base64
    */
    executeOCR (filetype, file) {
      let that = this
      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {
        'RIB': {
          creditorBankAccount: 'iban',
          beneficiaire: 'name'
        },
        'Order': {
          debtorName: 'debtorName',
          beneficiaire: 'beneficiary',
          creditorBankAccount: 'creditorBankAccount',
          remittanceInformation: 'reason',
          debtorBank: 'debtorBankAccount',
          debtorEmail: 'creditorMail',
          amount: 'amount',
          executionDate: 'date',
          attachmentReference: 'reference'
        },
        'INVOICE': {
          amount: 'Amount',
          recipientBankAccount: 'CreditorIBAN',
          beneficiaire: 'CreditorName',
          recipientEmail: 'CreditorEmail',
          remittanceInformation: 'Reason',
          attachmentReference: 'Reference',
          debtorBankAccount: 'Iban',
          executionDate: 'DeliveryDate'
        }
      }
      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading'))
      return that.$engine.ocr.ocrRequest(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        response = response.data.ControlsInformations
        // console.log('response', response)
        that.instantPayment = 0
        // Pour l'instant l'OCR ne marche qu'avec des IBAN
        this.recipientZoneCode = this.$engine.bankAccounts.getZoneData('EUR')
        const fileTypeData = exchangeData[filetype]
        for (var key in fileTypeData) {
          if (response[fileTypeData[key]]) {
            var ExtractedValue = response[fileTypeData[key]].Value
            // console.log(key, ' : ', ExtractedValue)
            if (ExtractedValue !== '$Error' &&
                ExtractedValue !== '$NotFound' &&
                ExtractedValue !== '') {
              that[key] = ExtractedValue
              if (key === 'beneficiaire') {
                let contacts = this.$engine.contacts.get()
                for (var kContact in contacts) {
                  if (contacts[kContact].name === ExtractedValue) {
                    that.recipientEmail = contacts[kContact].identifier
                    if (!response['CreditorIBAN'] || response['CreditorIBAN'].Value === '') {
                      that.recipientBankAccount = contacts[kContact].iban
                    }
                  }
                }
              } else if (key === 'executionDate') {
                let today = moment().format('YYYY-MM-DD')
                if (moment(ExtractedValue).format('YYYY-MM-DD') === today) {
                  that.instantPayment = 1
                }
              }
            }
          }
        }

        this.handleChangeRecipientZoneCode('EUR')

        /* TLV 03/2020 : Si l'IBAN expéditeur est reconnu par l'OCR, il n'est ajouté
          que s'il fait partie des comptes bancaires de l'utilisateur */
        if (response.Iban.Value) {
          let bankAccountsList = that.bankAccounts.filter(bank => bank.iban === response.Iban.Value)
          if (bankAccountsList.length > 0) {
            that.senderBank = bankAccountsList[0].iban
          }
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    formatIban () {
      if (this.recipientZoneCode.accountNumberField === 2) {
        if (validateAccountFormat(this.sortCode, this.recipientZoneCode.regexControl[0]) === null ||
            validateAccountFormat(this.accountNumber, this.recipientZoneCode.regexControl[1]) === null) {
          this.recipientBank = ''
        } else {
          this.recipientBank = createIbanUK(this.sortCode, this.accountNumber)
        }
      }
    },
    getNameDraft () {
      var namedraft = ''
      let that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-payment-create') {
        this.$f7.modal({
          title: that.$t('creation_forms.enter_drft_nm'),
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text" value="' + that.remittanceInformation + '"></div>',
          buttons: [
            {
              text: that.$t('common.cncl'),
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: that.$t('common.sve'),
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.SaveInDraft(namedraft)
              }
            }
          ]
        })
      } else {
        this.SaveInDraft(namedraft)
        reloadPage(that, {url: '/inbox/2/0'})
      }
    },
    handleChangeRecipientZoneCode (newCode) {
      const countries = this.countries.filter(country => country.label === newCode)
      if (countries.length > 0) {
        const country = countries[0]
        country.errors = {}
        this.recipientZoneCode = country

        /** TLV 19/03/2020
        * On extrait les donnees du faux IBAN en base en vraies donnees bancaires,
        * en fonction du pays, dans une variable locale appelee extractedBankData
        * qui permet d'afficher sur le formulaire les IBAN en fonction des pays
        */
        let extractedBankData = {}
        if (this.recipientZoneCode !== '' && this.recipientBankAccount !== '') {
          extractedBankData = extractForeignIban(this.recipientBankAccount, newCode)
        }
        let datavalues = {}
        for (var bankData in extractedBankData) {
          datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
        }
        this.recipientZoneCode.values = datavalues
        this.contactSelected = true
      }
    },
    importRIB ($event) {
      this.Dom7(this.Dom7('.rib-file-input')[this.Dom7('.rib-file-input').length - 1]).click()
    },
    isBankAccountAvailable (bankAccount) {
      if (this.$engine.rights.rightIs('dp_request_other_euro', false)) {
        return bankAccount.zoneCode === 'EUR'
      }
      return true
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 500000000) {
        this.createImage(files[0])
        this.attachmentName = files[0].name
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).val(this.attachmentName)
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size'))
      }
    },
    openCreateAttachmentInvoice () {
      loadPage(this, {url: '/attachments/createInvoice/'})
    },
    openDoc (attachmentId) {
      if (!this.attachement) {
        let that = this
        let win = window
        this.$f7.showPreloader(this.$t('common.getting_file'))
        this.$engine.services.payments.getAttachmentDetail(this.attachmentId)
          .then(response => {
            let blob = b64toBlob(response.data.documentData.split(',  ')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$t('common.got_file'),
              buttons: [
                {
                  text: that.$t('common.open'),
                  onClick: function () {
                    win.open(url)
                  }
                }
              ]
            })
          })
          .catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
          })
      } else {
        let blob = b64toBlob(this.attachement.split(',')[1], this.attachement.split(';')[0].replace(/^data:/, ''))
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      }
    },
    openImportAttachment (fileType) {
      if (fileType === '1') {
        let that = this
        that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
      }
      /* let that = this
      let buttons1
      if (this.hasCloudAttachments) {
        buttons1 = [
          {
            text: this.$t('common.import_device'),
            onClick: function () {
              that.attachement = ''
              that.attachmentName = ''
              that.attachmentId = ''
            }
          },
          {
            text: this.$t('creation_forms.imprt_frm_moneyroad'),
            onClick: function (event, event2) {
              that.attachement = ''
              that.attachmentName = ''
              that.attachmentId = ''
              that.filesPicker(event2)
            }
          },
          {
            text: this.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          }
        ]
      } else {
        buttons1 = [
          {
            text: this.$t('common.import_device'),
            onClick: function () {
              that.attachement = ''
              that.attachmentName = ''
              // that.attachmentReference = ''
              that.attachmentId = ''
              that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
            }
          },
          {
            text: this.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          }
        ]
      }
      this.$f7.actions(buttons1) */
    },
    orderKeys (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    refuseDraft () {
      let that = this
      this.$f7.modal({
        title: this.$t('directPayments.dp_draft_refused_rsn'),
        afterText: '<div class="item-input"><textarea class="inputrefusereason"></textarea></div>',
        buttons: [
          {
            text: this.$t('common.cncl'),
            color: 'red',
            onClick: function () {
              reloadPage(this, {url: '/inbox/2/0'})
              // NOTHING TO DO
            }
          },
          {
            text: this.$t('common.sve'),
            onClick: function () {
              that.refuseReason = that.Dom7('.inputrefusereason').val()
              that.SaveInDraft('', '2')
              loadPage(that, {url: '/inbox/2/1'})
            }
          }
        ]
      })
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists do you want to override it ? (' + fileName + ')', function (index) {
            console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    },
    SaveInDraft (namedraft, validateD = 0, directlySend = 0) {
      let that = this
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.modificationAccepted ? 'true' : 'false'
      this.recipientBankAccount = createForeignIban(that.recipientZoneCode)
      this.convertDateFormat()
      this.formatIban()
      if (validateD === '1') {
        let errFlag = this.validateForm()
        if (!errFlag) {
          this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
          return
        }
      }
      let draftArray = []
      if (that.capsule === 'draft-edit') {
        // let userLogin = that.$engine.accounts.get()[0].userAccts.filter(user => user.id === that.$engine.user.userAccountId)[0].login
        // let senderName = that.$engine.accounts.get().filter(user => user.identifier === userLogin)[0].name
        if (that.recipientZoneCode.label === 'GBP') {
          this.recipientBankAccount = createIbanUK(this.sortCode, this.accountNumber)
        }
        draftArray.push({
          'idDraft': that.idDraft,
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': this.recipientBankAccount,
          'CreditorIdentifier': this.recipientEmail,
          'CreditorName': this.beneficiaire,
          'DebtorName': this.$engine.user.get().name,
          'DebtorBankAccount': that.senderBank,
          'DebtorIdentifier': this.$engine.user.get().identifier,
          'RemittanceInformation': that.remittanceInformation,
          'ImmPmtAccepted': payModAcc,
          'PymtNtr': payNat,
          'RequestedExecutionDate': that.executionDate,
          'Amount': that.amount,
          'ModificationAccepted': that.modificationAccepted,
          'AttachmentId': that.attachmentId,
          'AttachmentName': that.attachmentName,
          'AttachmentReference': that.attachmentReference,
          'AttachmentType': that.fileIsFacturX ? 'FACTUR-X' : 'INVOICE',
          'Attachment': that.attachement,
          'DraftName': that.draftName,
          'creditorZoneCode': that.selectedDebtor.zoneCode,
          'debtorZoneCode': that.senderZoneCodeLabel,
          'validate': validateD,
          'groupValidator': this.idGroup,
          'validator': this.$engine.user.get().userAccountId,
          'refuseReason': this.refuseReason,
          'instantPayment': that.instantPayment,
          'creditorDecision': parseInt(that.decision),
          'currency': that.senderZoneCodeLabel,
          'activateOCR': that.isOcrActive === true ? '1' : '0'
        })
        this.$engine.dpDrafts.update(draftArray[0])
        .then(response => {
          if (response.status === 200) {
            /* TLV 23/01/2020
              Si le draft a été validé par le plus haut level pouvant le valider, alors il est directement envoyé
            */

            if (validateD === '1' && this.isHighestValidator && directlySend === '1') {
              this.sendDirectPayments(validateD, this.$engine.user.get().name)
            } else {
              this.$f7.modal({
                title: that.$t('creation_forms.svng_dp_drft'),
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/inbox/2/0'})
              }, 2000)
            }
          }
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      } else {
        if (that.recipientZoneCode.label === 'GBP') {
          this.recipientBankAccount = createIbanUK(this.sortCode, this.accountNumber)
        }
        draftArray.push({
          'idDraft': that.idDraft,
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': this.recipientBankAccount,
          'CreditorIdentifier': this.recipientEmail,
          'CreditorName': this.beneficiaire,
          'DebtorName': this.$engine.user.get().name,
          'DebtorBankAccount': that.senderBank,
          'DebtorIdentifier': this.$engine.user.get().identifier,
          'RemittanceInformation': that.remittanceInformation,
          'ImmPmtAccepted': payModAcc,
          'PymtNtr': payNat,
          'RequestedExecutionDate': that.executionDate,
          'Amount': that.amount,
          'ModificationAccepted': that.modificationAccepted,
          'AttachmentId': that.attachmentId,
          'AttachmentName': that.attachmentName,
          'AttachmentReference': that.attachmentReference,
          'AttachmentType': that.fileIsFacturX ? 'FACTUR-X' : 'INVOICE',
          'Attachment': that.attachement,
          'DraftName': namedraft,
          'creditorZoneCode': that.recipientZoneCode.label,
          'debtorZoneCode': that.senderZoneCodeLabel,
          'id_team': this.isSmartphone ? this.id_team[0] : this.id_team,
          'id_creator': this.$engine.user.get().userAccountId,
          'instantPayment': that.instantPayment,
          'creditorDecision': parseInt(that.decision),
          'currency': that.senderZoneCodeLabel,
          'activateOCR': that.isOcrActive === true ? '1' : '0'
        })
        let requestLoad = {
          'drafts': draftArray
        }
        that.$engine.dpDrafts.create(requestLoad)
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.$t('creation_forms.dp_draft_saved'),
              text: '<span class="preloader"></span>'
            })
            if (that.capsule === 'draft-create' || that.capsule === 'direct-payment-create') {
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/inbox/2/0', force: false, ignoreCache: false})
              }, 2000)
            } else {
              setTimeout(function () {
                that.$f7.closeModal()
                that.Dom7('.attachmentTaphold').removeClass('listItemSelected')
              }, 2000)
            }
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    scanOrder ($event) {
      /* eslint-disable no-undef */
      let that = this
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      if (this.$engine.settings.directPayments.get().ocrActivation === '1') {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()

              reader.onloadend = function (e) {
                executeOCR('Order', e.target.result.split(',')[1])
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      } else {
        console.log('OCR Non Actif')
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                that.attachement = e.target.result
              }

              let ca = that
              that.$f7.modal({
                title: 'Please enter the name of the scan',
                // text: 'Enter a name of draft',
                afterText: '<div class="item-input"><input class="inputnamescan" type="text"></div>',
                buttons: [
                  {
                    text: 'Cancel',
                    color: 'red',
                    onClick: function () {
                    }
                  },
                  {
                    text: 'Done',
                    onClick: function () {
                      var lab = ca.Dom7('.inputnamescan').val()
                      ca.attachmentName = lab
                    }
                  }
                ]
              })
              that.attachmentReference = ''
              that.attachmentId = ''

              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    scanRIB ($event) {
      /* eslint-disable no-undef */
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      if (this.$engine.settings.directPayments.get().ocrActivation === '1') {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                executeOCR('RIB', e.target.result.split(',')[1])
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    sendDirectPayments (validateD = 0, senderName = '') {
      let that = this
      let requestAlertText = this.$i18n.t('loading.sending')
      let responseAlertText = this.$i18n.t('success.DP_sent')

      let validatedForm = this.validateForm()
      console.log(validatedForm)

      if (!validatedForm) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      if (this.identifier.length > 0) {
        if (validateEmail(this.identifier) === null && validateSIREN(this.identifier) === null) {
          this.$f7.alert('Change the identifier format', 'Invalid Identifier')
          return
        }
      }
      this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
      this.$f7.showPreloader(requestAlertText)
      let jsonToCreate = {
        creditorIdentifier: this.recipientEmail,
        creditorName: this.beneficiaire,
        creditorBankAccount: this.recipientBankAccount,
        creditorZoneCode: this.recipientZoneCode.label,
        debtorZoneCode: this.senderZoneCodeLabel,
        debtorIdentifier: this.$engine.user.get().identifier,
        debtorName: (this.accountType === '1' && validateD === '1' && this.isHighestValidator) ? senderName : this.$engine.user.get().name,
        debtorBankAccount: this.senderBank,
        amount: this.amount,
        currency: this.senderZoneCodeLabel,
        executionDate: this.executionDate,
        reason: this.remittanceInformation,
        idDraft: this.idDraft,
        instantPayment: this.instantPayment,
        creditorDecision: parseInt(this.decision)
      }
      if (this.attachement) {
        jsonToCreate.attachmentName = this.attachmentName
        jsonToCreate.attachmentType = this.fileIsFacturX ? 'FACTUR-X' : 'INVOICE'
        jsonToCreate.attachmentReference = this.attachmentReference
        jsonToCreate.attachmentData = this.attachement
        jsonToCreate.attachmentId = this.attachmentId
      }
      that.$engine.services.directPayments
      .create(jsonToCreate)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          this.$f7.modal({
            title: responseAlertText,
            text: '<i class="icon fa fa-check"></i>'
          })
          this.$engine.services.directPayments.debtorList = []
          this.$engine.services.directPayments.contactDebtorList = []
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/inbox/'})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    setContacts () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({
          label: this.$engine.contacts.get(j).label,
          iban: this.$engine.contacts.get(j).iban,
          identifier: this.$engine.contacts.get(j).identifier,
          name: this.$engine.contacts.get(j).name,
          id: this.$engine.contacts.get(j).id,
          zoneCode: this.$engine.contacts.get(j).zoneCode
        })
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    setTeams () {
      let that = this
      // Init teams
      that.teams = that.$engine.accounts.getMembersGroup().filter(team => {
        return team.groups.find(group => {
          return group.members.map(member => member.id_user_account).includes(that.$engine.user.get().userAccountId)
        })
      })
      // Init teams default select
      if ((typeof that.teams) !== 'undefined' && that.teams.length > 0) {
        that.id_team = that.teams[0].id_team
        // Init teams select options
        for (var i = 0; i < that.teams.length; i++) {
          that.teamOptions[i] = {value: that.teams[i].id_team, text: that.teams[i].name}
        }
      }
    },
    switched () {
      this.fromCloud = !this.fromCloud
      this.attachmentName = ''
      this.attachement = ''
      this.attachmentId = ''
    },
    teamPicker (e) {
      e.stopPropagation()
      this.teamsPicker.open()
    },
    validateAndSaveButton () {
      let that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-payment-create') {
        this.$f7.modal({
          title: that.$t('creation_forms.enter_drft_nm'),
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text" value="' + that.remittanceInformation + '"></div>',
          buttons: [
            {
              text: that.$t('common.cncl'),
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: that.$t('common.sve'),
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.SaveInDraft(namedraft)
                this.valideDraft()
              }
            }
          ]
        })
      }
    },
    validateForm () {
      let that = this
      let maxAmountAuthorized = that.$engine.settings.directPayments.get().max_amount
      that.recipientBankAccount = createForeignIban(that.recipientZoneCode)
      let flagsList = {
        'beneficiaire': false,
        'senderBank': false,
        'recipientEmail': false,
        'remittanceInformation': false,
        'executionDate': false,
        'amount': false
      }
      let mandatoryValues = ['beneficiaire', 'senderBank', 'recipientEmail', 'remittanceInformation', 'executionDate', 'amount']
      let regexpValues = {
        'recipientEmail': 'EmailOrSIREN'
      }
      let intervalValues = {
        'amount': {
          'min': 0,
          'max': parseInt(maxAmountAuthorized)
        }
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      flagsList = verifyRegexpValues(regexpValues, flagsList, this)
      flagsList = verifyIntervalValues(intervalValues, flagsList, this)
      for (var i = 0; i < that.recipientZoneCode.accountNumberField; i++) {
        if (that.recipientZoneCode.accountLabel && !isEmptyValue(that.recipientZoneCode.values[that.recipientZoneCode.accountLabel[i]])) {
          if (!validateAccountFormat(that.recipientZoneCode.values[that.recipientZoneCode.accountLabel[i]], that.recipientZoneCode.regexControl[i])) {
            that.recipientZoneCode.errors[that.recipientZoneCode.accountLabel[i]] = 'incorrect'
            flagsList[that.recipientZoneCode.accountLabel[i]] = true
          } else {
            that.recipientZoneCode.errors[that.recipientZoneCode.accountLabel[i]] = 'no_error'
            flagsList[that.recipientZoneCode.accountLabel[i]] = false
          }
        } else if (isEmptyValue(that.recipientZoneCode.values[that.recipientZoneCode.accountLabel[i]])) {
          that.recipientZoneCode.errors[that.recipientZoneCode.accountLabel[i]] = 'IBAN '
          flagsList[that.recipientZoneCode.accountLabel[i]] = true
        }
      }
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    },
    valideAndSendDraft () {
      this.SaveInDraft('', '1', '1')
      reloadPage(this, {url: '/inbox/'})
    },
    valideDraft () {
      this.SaveInDraft('', '1')
      reloadPage(this, {url: '/inbox/2/0'})
    },
    view (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      const that = this
      this.$f7.showPreloader(this.$t('common.dwnldng_fl'))
      if (id) {
        this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', that.$t('errors.err_crtng_fl'))
              }
            )
          } else {
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            let url = window.URL.createObjectURL(blob)
            let fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
      } else {
        let blob = b64toBlob(this.attachement.split(',')[1], this.attachement.split(';')[0].replace(/^data:/, ''))
        let url = window.URL.createObjectURL(blob)
        let fileLink = document.createElement('a')
        fileLink.href = url
        fileLink.setAttribute('download', this.attachementNameLabel) // or any other extension
        fileLink.click()
        this.$f7.hidePreloader()
      }
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    console.error('error on saving file' + error.code)
                    alert('Unable to save file: ' + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
      // cordova.plugins.fileOpener2.open(file, fileType, {
      //   error: function (e) {
      //     // TODO : screen user stuff
      //     console.log('---------error----------')
      //   },
      //   success: function (s) {
      //     // TODO : screen user stuff
      //     console.log('---------success----------')
      //   }
      // })
      /* eslint-enable no-undef */
    }
  }
}
</script>

<style scoped>
.attachmentButton {
  min-width: 80px;
}
#cloud-label {
  color: #12bcf1;
  width: 30%;
  background-color: #e6e7e8;
  padding: 3px 3px 3px 3px;
  text-align: center;
  display: inline-block;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #12bcf1;
}
.custom-item-inner {
  width: 100%;
  padding: 8px 15px 7px 0px;
}
.facturePart2 {
  color: black;
}
.formLabelPayment{
    min-width: 65px !important;
    width: 40% !important;
    font-size: 12px;
}
.formTitle {
  color:white !important;
  text-align: center;
  margin: auto;
}
.input-group-text {
  font-size: small !important;
}
.test-after{
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  display: block;
  white-space: nowrap;
  color: #8e8e93;
  flex-shrink: 0;
  margin-left: auto;
  padding-left: 5px;
  max-height: 28px;
}
.test-content{
  border-style: solid;
  border-width: 1px;
  border-color: #EBEBED;

	min-height: 15px;

	box-sizing: border-box;
  padding-left: 15px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}
.test-inner{
  min-height: 15px;
  padding-right: 15px;
  position: relative;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 7px;

  box-sizing: border-box;
  display: flex;
  -webkit-box-flex: 1;

  overflow: hidden;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  align-self: stretch;
}
.test-title{
  color: #0E0144;
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// DPCreateTemplate.vue?324533a4